import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CurrencyPairsList.css';

class CurrencyPairsList extends Component {
  static get propTypes() {
    return {
      currencyPairs: PropTypes.array.isRequired,
      onRemove: PropTypes.func.isRequired,
    };
  }
  render() {
    const { currencyPairs, onRemove } = this.props;

    return (
      <div className="CurrencyPairsList">
        <table className="Admin-table CurrencyPairsList-table ">
          <tbody>
            <tr><th>Currency Pair</th><th>Delete</th></tr>
            {currencyPairs.map(p => (
              <tr key={p}>
                <td className="Name">{p}</td>
                <td className="Delete"><button className="CurrencyPairsList-table-delButton" onClick={() => onRemove(p)} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default CurrencyPairsList;



// WEBPACK FOOTER //
// ./src/admin/currencyPairs/CurrencyPairsList.js